import { Component, OnInit } from '@angular/core';
import * as servers from "../../services/api/servers";
import {urls} from "../../services/api/urls";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  consolidationUrl: string;
  constructor() { }

  ngOnInit() {
    this.consolidationUrl = servers.apiUrl + urls.cobidbService + urls.consolidation;
  }

}
